import { render, staticRenderFns } from "./TradesListGroupedByPhases.vue?vue&type=template&id=05af6eaa&scoped=true&"
import script from "./TradesListGroupedByPhases.vue?vue&type=script&lang=ts&"
export * from "./TradesListGroupedByPhases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af6eaa",
  null
  
)

export default component.exports